//Use event delegation for anchor links.
$(document).on("click", "a.tooltip-icon[href^='#']:not(:disabled), a.tooltip-link[href^='#']:not(:disabled)", function (e) {
    e.preventDefault();
    const elementClick = $(this).attr("href");
    const modalPopup = $(elementClick);

    if (modalPopup.hasClass("tooltip-popup")) {
        modalPopup.addClass("-open");
        $("body").addClass("overflow-hidden");
    }
});

//Combine event handlers for close buttons and modal overlays.
$(document).on("click", ".tooltip-popup .close-button, .tooltip-popup .modal-overlay", function (e) {
    const modalPopup = $(this).closest(".tooltip-popup");

    modalPopup.removeClass("-open");
    $("body").removeClass("overflow-hidden");
});